var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',_vm._l((_vm.vendors),function(vendor){return _c('v-col',{key:vendor.id,staticClass:"vendor-col",attrs:{"xs":"12","sm":"6","md":"4","lg":"3","xl":"2"}},[_c('v-card',{staticClass:"vendor-card"},[_c('router-link',{staticClass:"vendor-link",attrs:{"to":{
            name: 'vendor',
            params: { vendorId: vendor.id.toString() },
          }}},[(vendor.image)?_c('v-img',{staticClass:"vendor-image",attrs:{"src":vendor.image}}):_c('div',{staticClass:"vendor-image"})],1),_c('router-link',{staticClass:"vendor-link",attrs:{"to":{
            name: 'vendor',
            params: { vendorId: vendor.id.toString() },
          }}},[_c('v-card-title',{staticClass:"text-wrap"},[_vm._v(_vm._s(vendor.name))])],1),_c('v-card-actions',[_c('v-btn',{attrs:{"to":{
              name: 'vendor',
              params: { vendorId: vendor.id.toString() },
            },"color":"primary"}},[_vm._v(" Se meny ")])],1)],1)],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }